import type { PageBackground, PageColumns, PageContentWidth, PageSpacing } from "./types";

/** Shared, bounded choices for rendering and the upcoming Payload fields. */
export const PAGE_SPACING: Record<PageSpacing, number> = {
  none: 0,
  small: 12,
  medium: 24,
  large: 48,
};
export const PAGE_CONTENT_WIDTH: Record<PageContentWidth, number | "100%"> = {
  narrow: 760,
  standard: 1120,
  wide: 1368,
  full: "100%",
};
export const PAGE_COLUMNS: Record<PageColumns, string> = {
  one: "minmax(0, 1fr)",
  "40-60": "minmax(0, 2fr) minmax(0, 3fr)",
  "50-50": "minmax(0, 1fr) minmax(0, 1fr)",
  "60-40": "minmax(0, 3fr) minmax(0, 2fr)",
};
export const PAGE_BACKGROUND: Record<PageBackground, string> = {
  white: "#ffffff",
  muted: "#f4f6fc",
  brand: "#0b2ea1",
};
export const PAGE_DESKTOP_MEDIA = "@media (min-width: 992px)";
